import { useCallback } from "react";

const useKeyEvent = (key: string, postEvent: () => void) => {
  return useCallback(
    (event: Pick<KeyboardEvent, "key">) => {
      if (event.key.toUpperCase() === key.toUpperCase()) {
        postEvent();
      }
    },
    [key, postEvent],
  );
};

export default useKeyEvent;
